export const stats = {
    navatel: [
        { title: 'پایداری خدمات', number: 99.9, isDecimal: true, isPercent: true, symbol: "+" },
        { title: 'سال سابقه در حوزه تلکام', number: 25, symbol: "+" },
        { title: 'مشتری', number: 29768, symbol: "+" },
        { title: 'نصب اپلیکیشن', number: 271452, symbol: "+" },
        { title: 'استان فعال', number: 31 },
    ],
    navaApp: [
        { title: 'پایداری خدمات', number: 99.9, isDecimal: true, isPercent: true, symbol: "+" },
        { title: 'تماس موفق روزانه', number: 198000, symbol: "+" },
        { title: 'نصب موفق', number: 271452, symbol: "+" },
    ],
    webchat: [
        { title: 'پایداری خدمات', number: 99.9, isPercent: true, isDecimal: true, symbol: "+" },
        { title: 'مکالمات پاسخ‌داده‌شده', number: 70, isPercent: true, symbol: "+" },
        { title: 'زمان پاسخ اول', number: 1, symbol: ">" },
    ],
};